export const SCHOOL_TIMEZONE = 'America/Chicago';

type DateOnlyInput =
    | Date
    | string
    | number
    | { seconds?: number; _seconds?: number; toDate?: () => Date }
    | null
    | undefined;

const toDate = (value: DateOnlyInput): Date | null => {
    if (!value) return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
    if (typeof value === 'string' || typeof value === 'number') {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
    }
    if (typeof value.toDate === 'function') {
        const date = value.toDate();
        return Number.isNaN(date.getTime()) ? null : date;
    }

    const seconds = value.seconds ?? value._seconds;
    if (typeof seconds === 'number') {
        const date = new Date(seconds * 1000);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    return null;
};

const dateKeyFromUtcDateParts = (date: Date): number =>
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());

const dateKeyInTimeZone = (date: Date, timeZone: string): number => {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    }).formatToParts(date);

    const year = Number(parts.find(part => part.type === 'year')?.value);
    const month = Number(parts.find(part => part.type === 'month')?.value);
    const day = Number(parts.find(part => part.type === 'day')?.value);

    return Date.UTC(year, month - 1, day);
};

export const formatDateOnly = (value: DateOnlyInput): string => {
    const date = toDate(value);
    if (!date) return '-';

    return `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
};

export const isDateOnlyTodayOrFuture = (
    value: DateOnlyInput,
    timeZone = SCHOOL_TIMEZONE
): boolean => {
    const date = toDate(value);
    if (!date) return false;

    return dateKeyInTimeZone(new Date(), timeZone) <= dateKeyFromUtcDateParts(date);
};
